import { LogLevels, createConsoleLogger } from '@powersync/common';
/**
 * Broadcasts logs to all clients
 */
export class BroadcastLogger {
    clients;
    inner;
    currentLevel = LogLevels.info;
    sendBroadcasts = true;
    constructor(prefix, clients) {
        this.clients = clients;
        this.inner = createConsoleLogger({ prefix: prefix });
    }
    log(record) {
        this.inner.log(record);
        if (this.sendBroadcasts && record.level >= this.currentLevel) {
            const sanitized = this.sanitizeRecord(record);
            this.iterateClients((client) => client.clientProvider.log(sanitized));
        }
    }
    /**
     * Set the global log level.
     */
    setLevel(level) {
        this.inner.minLevel = level;
        this.currentLevel = level;
    }
    /**
     * Iterates all clients, catches individual client exceptions
     * and proceeds to execute for all clients.
     */
    async iterateClients(callback) {
        for (const client of this.clients) {
            try {
                await callback(client);
            }
            catch (ex) {
                console.error('Caught exception when iterating client', ex);
            }
        }
    }
    /**
     * Guards against any logging errors.
     * We don't want a logging exception to cause further issues upstream
     */
    sanitizeRecord(record) {
        if (!record.error) {
            return record;
        }
        let error;
        try {
            // Try and clone here first. If it fails it won't be passable over a MessagePort
            error = structuredClone(record.error);
        }
        catch (ex) {
            console.error(ex);
            error = 'Could not serialize log params. Check shared worker logs for more details.';
        }
        return {
            ...record,
            error
        };
    }
}
//# sourceMappingURL=BroadcastLogger.js.map